import React from 'react';
import { Form, Radio, RadioChangeEvent } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler, Placeholder, InfoTooltip } from '@common/components';
import { ENUM_QUERY } from '@common/graphql';

export function ShiftTypesRadioInput({
  tooltipMessage,
  hidden = false,
  onChange,
  disabled,
  ...props
}: {
  tooltipMessage?: string;
  hidden?: boolean;
  onChange?: (event: RadioChangeEvent) => void;
  disabled?: boolean;
}) {
  const { loading, error, data } = useQuery(ENUM_QUERY, {
    variables: { key: 'WorksShiftType' },
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="ShiftTypesRadioInput"
        messageType="contextual"
      />
    );
  }

  return (
    <div className="shift-types-radio-input">
      <Placeholder.Input loading={loading} size="large" width={308}>
        <Form.Item
          label={
            <>
              Shift type
              {tooltipMessage && (
                <InfoTooltip size="md" leftOffset="sm" title={tooltipMessage} />
              )}
            </>
          }
          name="shiftType"
          rules={[{ required: true, message: 'Please enter the shift type' }]}
          hidden={hidden}
        >
          <Radio.Group
            buttonStyle="solid"
            size="large"
            onChange={onChange}
            disabled={disabled}
            {...props}
          >
            {data?.enum.map(({ name, description }) => (
              <Radio.Button key={name} value={name}>
                {description}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>
      </Placeholder.Input>
    </div>
  );
}
